export { default } from './FileInput.tsx'
export type { FileInputOptions } from './FileInput.tsx'
